import {Injectable} from '@angular/core';
import {Language} from "../interfaces/language";
import {MessageService} from "@progress/kendo-angular-l10n";
import {BehaviorSubject, Observable} from "rxjs";

export enum RtlEnum {
	rtl,
	ltr
}

@Injectable({
	providedIn: 'root'
})
export class RtlService {
	public loginRtlModeSubject: BehaviorSubject<boolean>;
	public rtlModeObservable: Observable<boolean>;

	private rtlMode: boolean;
	private rtlModeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

	constructor(private messages: MessageService) {
		this.rtlMode = false;
		this.rtlModeSubject.next(this.rtlMode);
		this.loginRtlModeSubject = new BehaviorSubject(null);
		this.rtlModeObservable = this.rtlModeSubject.asObservable();
	}

	/**
	 * Checks if application is in rtl mode
	 */
	public isRtl(): boolean {
		return this.rtlMode;
	}

	/**
	 * Returns loginRtlModeSubject observable
	 */
	public getLoginRtlModeObservable(): Observable<boolean> {
		return this.loginRtlModeSubject.asObservable();
	}

	/**
	 * Sets application direction
	 * @param lang
	 * @param loginInProgress
	 */
	public setDir(lang: Language, loginInProgress: boolean) {
		if (!loginInProgress) {
			this.setLoginDir(lang.rightToLeft);
		}
		this.rtlMode = lang.rightToLeft;
		this.rtlModeSubject.next(this.rtlMode);
		document.dir = RtlEnum[this.rtlMode ? 0 : 1];
		this.messages.notify(this.rtlMode);
	}

	public setLoginDir(isRtl: boolean) {
		this.loginRtlModeSubject.next(isRtl);
	}
}
